module.exports = __webpack_public_path__ + "img/maintop.09e362f.png";